import { BaseService } from './api'
import type { OrderbookQueryParams, OrderbookResponse, OrderbookItem } from '@/types/otc'

export class OTCService extends BaseService {
  async getOrderbook(params?: OrderbookQueryParams): Promise<OrderbookResponse> {
    try {
      const response = await this.api.get<OrderbookResponse>('/orderbook', { params })
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch orderbook')
      }
      return response.data
    } catch (error) {
      this.handleError(error)
    }
  }

  async getHotDeals(): Promise<OrderbookItem[]> {
    try {
      const response = await this.getOrderbook({ limit: 5 })
      return response.data
    } catch (error) {
      this.handleError(error)
    }
  }

  async getIndustries(): Promise<string[]> {
    try {
      const response = await this.get<{ data: string[] }>('/orderbook/industries')
      return response.data || []
    } catch (error) {
      console.error('Failed to fetch industries:', error)
      return []
    }
  }
}

export const otcService = new OTCService() 